import { MappingDisplayItemTypes } from '../../enums/adjustments-and-reclasses/MappingDisplayItemTypes.enum';
import { IMappingDisplayItemBasic } from '../../interfaces/adjustments-and-reclasses/IMappingDisplayItemBasic.interface';
import { CreateReclassesHandler } from './CreateReclassesHandler.type';

export type MappingDisplayItemWithNoForm = IMappingDisplayItemBasic &
    (
        | {
              type: MappingDisplayItemTypes.GROUP_TOTAL | MappingDisplayItemTypes.SUBTOTAL;
          }
        | {
              type: MappingDisplayItemTypes.FLI | MappingDisplayItemTypes.SUB_FLI;
              createReclassesAccount: CreateReclassesHandler;
          }
    );
